// src/hooks/useReprint.js
import { useState } from "react";
import api from "../services/api";

export function useReprint() {
  const [showReprintModal, setShowReprintModal] = useState(false);
  const [invoiceToReprint, setInvoiceToReprint] = useState(null);
  const [loadingReprint, setLoadingReprint] = useState(false);

  const handleOpenReprint = async (invoice) => {
    setLoadingReprint(true);
    try {
      const response = await api.get(`/invoices/${invoice.id}/reprint`);
      setInvoiceToReprint(response.data);
      setShowReprintModal(true);
    } catch (error) {
      console.error("Error cargando datos para reimpresión:", error);
    } finally {
      setLoadingReprint(false);
    }
  };

  const handleCloseReprint = () => {
    setShowReprintModal(false);
    setInvoiceToReprint(null);
  };

  return {
    showReprintModal,
    invoiceToReprint,
    loadingReprint,
    handleOpenReprint,
    handleCloseReprint,
  };
}